import 'react';
import './Provider/ThemeContext.js';
import 'classnames';
import { css } from 'emotion';
import '@emotion/core';
import 'emotion-theming';
import '@emotion/styled';
import { a as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers.js';
import './ColorMode/ColorModeContext.js';
import 'lodash/kebabCase';
import 'tinycolor2';
import { t as theme, a as altitude, s as space } from './getCSSFromStyleObject.js';
import 'lodash/uniq';
import 'reakit/Id';
import 'deepmerge';
import 'lodash/set';
import 'lodash/get';
import 'capsize';
import '@emotion/is-prop-valid';
import './utils/OutsideClickHandler.js';
import { a as Menu, b as MenuItem, c as MenuItemIcon, d as MenuDivider, e as MenuGroup, f as MenuGroupTitle, g as MenuOptionGroup, h as MenuOptionItem, i as MenuOptionItemIconWrapper } from './Menu.styles.js';

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", " !important;\n\n  ", "\n\n  padding: ", "rem 0;\n  position: absolute;\n  min-width: 200px;\n  width: unset;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var DropdownMenu = function DropdownMenu(styleProps) {
  return css(_templateObject(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var DropdownMenuPopover = function DropdownMenuPopover(styleProps) {
  return css(_templateObject2(), altitude(styleProps.altitude)(styleProps), Menu(styleProps), space(2)(styleProps));
};
var DropdownMenuItem = function DropdownMenuItem(styleProps) {
  return css(_templateObject3(), MenuItem(styleProps));
};
var DropdownMenuButton = function DropdownMenuButton(styleProps) {
  return css(_templateObject4(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var DropdownMenuDisclosure = function DropdownMenuDisclosure(styleProps) {
  return css(_templateObject5(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var DropdownMenuItemIcon = function DropdownMenuItemIcon(styleProps) {
  return css(_templateObject6(), MenuItemIcon(styleProps));
};
var DropdownMenuDivider = function DropdownMenuDivider(styleProps) {
  return css(_templateObject7(), MenuDivider(styleProps));
};
var DropdownMenuGroup = function DropdownMenuGroup(styleProps) {
  return css(_templateObject8(), MenuGroup(styleProps));
};
var DropdownMenuGroupTitle = function DropdownMenuGroupTitle(styleProps) {
  return css(_templateObject9(), MenuGroupTitle(styleProps));
};
var DropdownMenuOptionGroup = function DropdownMenuOptionGroup(styleProps) {
  return css(_templateObject10(), MenuOptionGroup(styleProps));
};
var DropdownMenuOptionItem = function DropdownMenuOptionItem(styleProps) {
  return css(_templateObject11(), MenuOptionItem(styleProps));
};
var DropdownMenuOptionItemIconWrapper = function DropdownMenuOptionItemIconWrapper(styleProps) {
  return css(_templateObject12(), MenuOptionItemIconWrapper(styleProps));
};

var DropdownMenu_styles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DropdownMenu: DropdownMenu,
  DropdownMenuPopover: DropdownMenuPopover,
  DropdownMenuItem: DropdownMenuItem,
  DropdownMenuButton: DropdownMenuButton,
  DropdownMenuDisclosure: DropdownMenuDisclosure,
  DropdownMenuItemIcon: DropdownMenuItemIcon,
  DropdownMenuDivider: DropdownMenuDivider,
  DropdownMenuGroup: DropdownMenuGroup,
  DropdownMenuGroupTitle: DropdownMenuGroupTitle,
  DropdownMenuOptionGroup: DropdownMenuOptionGroup,
  DropdownMenuOptionItem: DropdownMenuOptionItem,
  DropdownMenuOptionItemIconWrapper: DropdownMenuOptionItemIconWrapper
});

export { DropdownMenu_styles as D, DropdownMenu as a, DropdownMenuItem as b, DropdownMenuItemIcon as c, DropdownMenuButton as d, DropdownMenuPopover as e, DropdownMenuGroup as f, DropdownMenuGroupTitle as g, DropdownMenuOptionGroup as h, DropdownMenuOptionItem as i, DropdownMenuOptionItemIconWrapper as j, DropdownMenuDivider as k, DropdownMenuDisclosure as l };
